var _path, _polygon, _polygon2, _polygon3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 116 88.2",
    style: {
      enableBackground: "new 0 0 116 88.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.2,67V21.2c0-5.9-4-10.9-9.5-12.4l3.2-3.2h6.4V0H56.5v5.7h6.4L66,8.8c-5.5,1.5-9.5,6.5-9.5,12.4V67 c0,5.9,4,10.9,9.5,12.4l-3.2,3.2h-6.4v5.7h25.7v-5.7h-6.4l-3.2-3.2C78.1,78,82.2,73,82.2,67z M75.8,66.9c0,3.6-2.9,6.5-6.5,6.5 c-3.6,0-6.5-2.9-6.5-6.5V21.3c0-3.6,2.9-6.5,6.5-6.5c3.6,0,6.5,2.9,6.5,6.5V66.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "87,0 87,5.7 95,5.7 98.2,8.9 95,12.1 93.5,12.1 88.6,12.1 87,12.1 87,88.2 93.5,88.2 93.5,18.6 98.2,18.6  98.2,88.2 104.7,88.2 104.7,18.6 109.5,18.6 109.5,88.2 116,88.2 116,12.1 114.3,12.1 109.5,12.1 107.9,12.1 104.7,8.9 107.9,5.7  116,5.7 116,0 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.2,37.7 39.7,43.3 34.1,37.7 34.1,0 27.7,0 27.7,88.2 34.1,88.2 34.1,50.6 39.7,44.9 45.2,50.6 45.2,88.2  51.7,88.2 51.7,0 45.2,0 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "15.2,41.3 15.2,0 8.8,0 8.8,41.3 0,41.3 0,46.9 5.7,46.9 8.8,50 8.8,88.2 15.2,88.2 15.2,50 18.3,46.9 24,46.9  24,41.3 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7a0ba444cbc89e96dc2c5c317d899f83.svg";
export { ForwardRef as ReactComponent };